import { render, staticRenderFns } from "./MasterPengutamaan.vue?vue&type=template&id=af092f88"
import script from "./MasterPengutamaan.vue?vue&type=script&lang=js"
export * from "./MasterPengutamaan.vue?vue&type=script&lang=js"
import style0 from "./MasterPengutamaan.vue?vue&type=style&index=0&id=af092f88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports